import { FC, useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Route } from '@core/routes/Route';
import { getFullApiLink } from '@core/utils/url';

const ConceptPage: FC = () => {
    const location = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoadedFirstTime, setIsLoadedFirstTime] = useState(false);

    const isCreateRoute = location.pathname === Route.ConceptPageCreate;
    const safeId = parseInt(id ?? '') || null;

    const src = useMemo(() => {
        if (isCreateRoute) return getFullApiLink('/ConceptLockerItem/');
        if (safeId) return getFullApiLink(`/ConceptLockerItem/Edit/${safeId}`);
    }, [isCreateRoute, safeId]);

    const checkLoad = useCallback(() => {
        if (!isLoadedFirstTime) {
            setIsLoadedFirstTime(true);
        } else {
            navigate(Route.MyConcepts);
        }
    }, [isLoadedFirstTime, navigate]);

    if (!src) navigate(Route.MyConcepts);

    return (
        <iframe
            onLoad={checkLoad}
            title="Create concept"
            src={src}
            style={{
                width: '100%',
                height: 'calc(100vh - 80px)',
            }}
        />
    );
};

export default ConceptPage;